import XKernelLogo from "./x_kernel.svg";
import XKelp from "./x_kelp.svg";

export { XKernelLogo, XKelp };
